<template>
	<div class="page-wrapper">
		<div class="page-content">
			<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
				<div class="breadcrumb-title pe-3">Location Page CMS</div>
				<div class="ps-3">
					<nav aria-label="breadcrumb">
						<ol class="breadcrumb mb-0 p-0">
							<li class="breadcrumb-item">
								<router-link to="/dashboard">
									<i class="bx bx-home-alt"></i>
								</router-link>
							</li>
							<li class="breadcrumb-item active" aria-current="page">Location Page CMS</li>
						</ol>
					</nav>
				</div>
			</div>
			<form @submit.prevent="updateCms()">
				<div class="card">
					<div class="card-body">
						<h5 class="card-title">Location Page CMS</h5>
						<hr />
						<div class="form-body mt-4">
							<div class="row">
								<div class="col-lg-8 mb-3">
									<div class="border border-3 p-4 rounded">
										<div class="row">
											<div class="col-12 mb-3">
												<label class="form-label">Location Page Title:</label>
												<input type="text" v-model="cmsData.title" class="form-control" id="inputPageHeaderTitle" placeholder="Enter location page title" />
											</div>
											<div class="col-12 mb-3">
												<label class="form-label">Location Page Subtitle:</label>
												<input type="text" v-model="cmsData.subTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter location page title" />
											</div>
											<div class="col-12 mb-3">
												<label class="form-label">Placeholder Title:</label>
												<input type="text" v-model="cmsData.placeholderTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter location page title" />
											</div>
											<div class="col-12 mb-3">
												<label class="form-label">Placeholder Divider Title:</label>
												<input type="text" v-model="cmsData.dividerTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter location page title" />
											</div>
											<div class="row">
												<div class="col-6 mb-3">
													<label class="form-label">Search Button Title:</label>
													<input type="text" v-model="cmsData.searchButtonTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter contact icon"/>
												</div>
												<div class="col-6 mb-3">
													<label class="form-label">Allow Access Title</label>
													<input type="text" v-model="cmsData.allowAccessTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter location icon"/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="d-grid col-12 col-lg-8">
									<button type="submit" class="btn btn-primary">Save</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script src="../js/location-page-cms.js"></script>